import { buildOtpAuthUrl, generateTotpSecret, verifyTotpCode } from '../crypto/totp.ts'

const KEY_ENABLED = 'zion_totp_enabled'
const KEY_SECRET = 'zion_totp_secret'
const KEY_PENDING = 'zion_totp_pending_secret'

export function isTotpEnabled(): boolean {
  try {
    return localStorage.getItem(KEY_ENABLED) === '1' && !!localStorage.getItem(KEY_SECRET)?.trim()
  } catch {
    return false
  }
}

export function getTotpSecret(): string | null {
  try {
    const s = localStorage.getItem(KEY_SECRET)?.trim()
    return s || null
  } catch {
    return null
  }
}

/** Avvia enrollment: genera segreto temporaneo (non ancora attivo). */
export function beginTotpEnrollment(): { secret: string; otpauthUrl: string } {
  const secret = generateTotpSecret()
  localStorage.setItem(KEY_PENDING, secret)
  const account = 'zion-local'
  return { secret, otpauthUrl: buildOtpAuthUrl(secret, account, 'ZION') }
}

export function getPendingTotpSecret(): string | null {
  try {
    return localStorage.getItem(KEY_PENDING)?.trim() || null
  } catch {
    return null
  }
}

export function cancelTotpEnrollment(): void {
  try {
    localStorage.removeItem(KEY_PENDING)
  } catch {
    /* ignore */
  }
}

/** Conferma con codice a 6 cifre → attiva 2FA. */
export async function confirmTotpEnrollment(code: string): Promise<boolean> {
  const pending = getPendingTotpSecret()
  if (!pending) return false
  const ok = await verifyTotpCode(pending, code)
  if (!ok) return false
  localStorage.setItem(KEY_SECRET, pending)
  localStorage.setItem(KEY_ENABLED, '1')
  localStorage.removeItem(KEY_PENDING)
  return true
}

export async function verifyActiveTotp(code: string): Promise<boolean> {
  const secret = getTotpSecret()
  if (!secret || !isTotpEnabled()) return false
  return verifyTotpCode(secret, code)
}

export function disableTotp(): void {
  try {
    localStorage.removeItem(KEY_ENABLED)
    localStorage.removeItem(KEY_SECRET)
    localStorage.removeItem(KEY_PENDING)
  } catch {
    /* ignore */
  }
}

export function clearTotpStorage(): void {
  disableTotp()
}
